// @flow
import * as React from 'react';

export const CheckboxContext = React.createContext();
type Props = {
    children: React.Node,
};
const CheckboxContextProvider = (props: Props) => {
    const { children } = props;

    const [
        selected: {[number]: any},
        setSelected: ({ index: number, [string]: any }) => void,
    ] = React.useState({});

    const [selectAll, setSelectAll] = React.useState(false);

    const handleSelect = (index, item) => {
        setSelected((currSelected) => {
            const newSelected = { ...currSelected };
            newSelected[index] = item;
            return newSelected;
        });
    };

    const handleUnselect = (index) => {
        setSelected((currSelected) => {
            const newSelected = { ...currSelected };
            delete newSelected[index];
            return newSelected;
        });
    };

    return (
        <CheckboxContext.Provider
            value={{
                setSelected,
                selectAll,
                onSelectAll: setSelectAll,
                selected,
                onSelect: handleSelect,
                onUnselect: handleUnselect,
            }}
        >
            {children}
        </CheckboxContext.Provider>
    );
};
export default CheckboxContextProvider;
